import { Component, OnInit, Output, OnDestroy, EventEmitter } from '@angular/core';
import { ModalService } from '@services/modal.service';

@Component({
  selector: 'app-modal-request-status',
  templateUrl: './modal-request-status.component.html',
  styleUrls: ['./modal-request-status.component.scss']
})
export class ModalRequestStatusComponent implements OnDestroy {

  @Output() confirm: EventEmitter<object> = new EventEmitter();
  constructor(public modal: ModalService) {  }

  ngOnDestroy() {
    this.modal.close();
  }

  accept() {
    this.modal.close();
    this.confirm.emit();
  }
}
